import {
  ChartAdapter,
  ChartBuildContext,
  EChartsOption,
  RadarChartSettings,
} from "../types";

import {
  buildLegend,
  buildTooltip,
  mergeRadarSettings,
} from "./shared";

const radarChartAdapter: ChartAdapter<"radar"> = {
  type: "radar",
  buildOption: (ctx: ChartBuildContext<"radar">) => {
    const { data } = ctx;
    const settings = mergeRadarSettings(ctx.settings);

    const legend = buildLegend(data.legend, settings.legend);
    const tooltip = buildTooltip(data.tooltip, {
      trigger: settings.tooltip?.trigger ?? "item",
      enable: settings.tooltip?.enable,
      formatter: settings.tooltip?.formatter,
    });

    const radar = {
      shape: settings.shape ?? "polygon",
      splitNumber: settings.splitNumber ?? 5,
      indicator: data.indicators.map((indicator) => ({
        name: indicator.name,
        max: indicator.max,
        min: indicator.min,
      })),
    };

    const showSymbol = settings.showSymbol ?? true;
    const areaDefault = settings.areaDefault ?? false;

    const series = [
      {
        type: "radar",
        symbol: showSymbol ? "circle" : "none",
        symbolSize: showSymbol ? 6 : 0,
        data: data.series.map((seriesItem) => ({
          name: seriesItem.name,
          value: seriesItem.values.map((value) =>
            typeof value === "number" ? value : 0
          ),
          lineStyle: seriesItem.lineWidth
            ? { width: seriesItem.lineWidth }
            : undefined,
          itemStyle: seriesItem.color ? { color: seriesItem.color } : undefined,
          areaStyle:
            seriesItem.area ?? areaDefault
              ? {
                  opacity: 0.25,
                  color: seriesItem.color,
                }
              : undefined,
        })),
      },
    ];

    const option: EChartsOption = {
      tooltip,
      legend,
      radar,
      series,
    };

    return option;
  },
  getDefaultSettings: (): Partial<RadarChartSettings> => ({
    legend: { show: true, position: "top" },
    tooltip: { enable: true, trigger: "item" },
    shape: "polygon",
    splitNumber: 5,
    showSymbol: true,
    areaDefault: false,
  }),
};

export default radarChartAdapter;

